







import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
  inheritAttrs: false,

  props: {
    src: {
      type: String,
    },
    placeholder: {
      type: String,
    },
  },
    
  setup(props) {
    const imageSrc = computed(() => props.src ? props.src : null);

    return {
      imageSrc,
    };
  }, 
});
